import * as _ from 'lodash';
import { DepartmentUpperManagerViewModel } from '../../common-api/system-management-api';
import { ROUTE_STATE_KEY } from '../../core/constants/global-constants.constant';
import { RouteState } from '../../core/models';
import { SessionStorageService, UserProfileService } from '../../core/services';
import { SessionStorageEnum } from '../enums/session-storage.enum';

/**
 * 取得登入者目前使用功能公司別
 * @returns string
 */
const getCompanyId = (): string => {
  const sessionStorageService = new SessionStorageService();
  const routes: RouteState[] = sessionStorageService.getItem(ROUTE_STATE_KEY);

  const correspondingRouteData = _.last(routes)?.data;
  const routeData = correspondingRouteData;
  const caseNo = routeData?.caseNo ?? '';
  const companyId = routeData?.companyId;
  let useCompnanyId = '';
  const contextData = sessionStorageService.getItem(
    SessionStorageEnum.CONTEXT_DATA
  );
  console.log(
    'getCompanyId',
    routes,
    correspondingRouteData,
    routeData,
    companyId
  );
  if (contextData) useCompnanyId = contextData?.companyId.toString();
  else if (companyId) useCompnanyId = companyId;
  else {
    throw new Error('Cannot get Company Id');
  }
  return useCompnanyId;
};
/**
 * 取得目前登入者的主職部門
 * @param userProfileService 需傳入service
 * @returns
 */
const getDeptId = (userProfileService: UserProfileService): number => {
  let useDeptId = 0; // 後端目前部門ID預設為不可NULL，故預設值先放0
  // 當前使用者所屬部門 (job title 會有多筆的情況，要帶入 mainDuty=true 的 departmentId)
  const userDeptId = userProfileService.userProfile?.userJobTitles?.find(
    (u) => u.mainDuty
  )?.department?.departmentId;
  if (userDeptId || userDeptId == 0) {
    useDeptId = userDeptId;
  } else {
    console.log('Cannot get Dept Id');
  }
  return useDeptId;
};
/**
 * 取得目前登入者的主職部門資訊
 * @param userProfileService 需傳入service
 * @returns
 */
const getDeptInfo = (
  userProfileService: UserProfileService
): DepartmentUpperManagerViewModel => {
  let useDeptInfo = {} as DepartmentUpperManagerViewModel;
  // 當前使用者所屬部門 (job title 會有多筆的情況，要帶入 mainDuty=true 的 departmentId)
  useDeptInfo =
    userProfileService.userProfile?.userJobTitles?.find((u) => u.mainDuty)
      ?.department || {};

  return useDeptInfo;
};
/**
 * 確認自身是否為主管
 * @param userProfileService
 * @returns
 */
const checkSelfIsManager = (
  userProfileService: UserProfileService
): boolean => {
  let checker = false;
  const mainProfile = getDeptInfo(userProfileService);
  const loginUserNo = userProfileService.userProfile.userNo;
  if (mainProfile.authenticationUserNo === loginUserNo) checker = true;
  return checker;
};
/**
 * 確認本身主職的workType
 * @param userProfileService
 * @param useWorkType
 * @returns
 */
const checkSelfIsWorkType = (
  userProfileService: UserProfileService,
  useWorkType: number
): boolean => {
  let checker = false;
  const mainProfile = getDeptInfo(userProfileService);

  if (mainProfile.workType === useWorkType) checker = true;
  return checker;
};
export {
  checkSelfIsManager,
  checkSelfIsWorkType,
  getCompanyId,
  getDeptId,
  getDeptInfo,
};
